import store from '@/store';

export const Viewers = {
    state: {
        view1Type: '',
        view2Type: '',
        view3Type: '',
        view4Type: '',

        isView1Visible: true,
        isView2Visible: false,
        isView3Visible: false,
        isView4Visible: false,

        adminModelGeometryLoadedCallback: null,

        compareModeImage: null,
        isLeftMenuPinned: false,
    },

    mutations: {
        SET_VIEW_1_TYPE (state, value){
            state.view1Type = value;
        },
        SET_VIEW_2_TYPE (state, value){
            state.view2Type = value;
        },
        SET_VIEW_3_TYPE (state, value){
            state.view3Type = value;
        },
        SET_VIEW_4_TYPE (state, value){
            state.view4Type = value;
        },
        SET_IS_VIEW_1_VISIBLE (state, value){
            state.isView1Visible = value;
        },
        SET_IS_VIEW_2_VISIBLE (state, value){
            state.isView2Visible = value;
        },
        SET_IS_VIEW_3_VISIBLE (state, value){
            state.isView3Visible = value;
        },
        SET_IS_VIEW_4_VISIBLE (state, value){
            state.isView4Visible = value;
        },
        SET_COMPARE_MODE_IMAGE (state, value) {
            state.compareModeImage = value;
        },
        SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK (state, value) {
            state.adminModelGeometryLoadedCallback = value;
        },
        SET_IS_LEFT_MENU_PINNED (state, value) {
            state.isLeftMenuPinned = value;
        },
    },
    getters: {
        GET_VIEW_1_TYPE (state){
            return state.view1Type;
        },
        GET_VIEW_2_TYPE (state){
            return state.view2Type;
        },
        GET_VIEW_3_TYPE (state){
            return state.view3Type;
        },
        GET_VIEW_4_TYPE (state){
            return state.view4Type;
        },
        GET_IS_VIEW_1_VISIBLE (state){
            return state.isView1Visible;
        },
        GET_IS_VIEW_2_VISIBLE (state){
            return state.isView2Visible;
        },
        GET_IS_VIEW_3_VISIBLE (state){
            return state.isView3Visible;
        },
        GET_IS_VIEW_4_VISIBLE (state){
            return state.isView4Visible;
        },
        GET_COMPARE_MODE_IMAGE (state) {
            return state.compareModeImage;
        },
        GET_IS_COMPARE_MODE_AVAILABLE (state){
            let result = 0;
            for (let i = 1; i <= 4; i++) {                
                if ((state[`view${i}Type`] == "360") || (state[`view${i}Type`] == "3d")) {
                    result++;
                }
            }
            return result == 2;            
        },
        GET_360_IMAGE_IN_VIEWER (state) {
            for (let i = 1; i <= 4; i++) {                
                if (state[`view${i}Type`] === "360") {
                    return state[`isView3${i}Visible`] ? store.state.selectedImage : null;
                }
            }
            return null;
        },
        GET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK (state) {
            return state.adminModelGeometryLoadedCallback;
        },
        GET_IS_LEFT_MENU_PINNED (state) {
            return state.isLeftMenuPinned;
        },
    },
    actions: {
        
    },

}